import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

const PREFIX = `${baseUrl}/joins-sales-cloud/v1/houseCode`;

// 按店铺关键字搜索地址建议（一户一码）
export const suggestByShop = (keyword) => {
  const params = parseParam({ keyword });
  return request({
    url: `${PREFIX}/suggest?${params}`,
    method: 'GET'
  });
};
